import { MCard } from "components/Shared";
import Speedometer, { getDefaultColor4Segment } from "components/Shared/Speedometer";
import { AuditTotalPercent, QaTimeCardResponseDetail } from "interfaces/Mueller.Business.Models";
import React, { useEffect, useRef, useState } from "react";
import { getTimeLogSpeedometerDataForCurrentUser } from "requests/qualityAssurance";

interface Props {
  internetUserId: number;
}

const QAPerformanceSpeedometers = ({ internetUserId }: Props) => {
  const mounted = useRef(true);
  const [speedometerData, setSpeedometerData] = useState<QaTimeCardResponseDetail>();

  useEffect(
    () => () => {
      mounted.current = false;
    },
    [],
  );

  useEffect(() => {
    getTimeLogSpeedometerDataForCurrentUser(mounted, setSpeedometerData);
  }, [internetUserId]);

  // needed to cast 0s to null, but for rejectection 0s/null had to go to 1
  const handleEmptyValue = (value: AuditTotalPercent, defaultValue: number = null) =>
    value?.totalCount > 0 ? value?.amount : defaultValue;
  const startValue = 0.5;

  return (
    <MCard title="Performance" cardContentClassName="qa-performance-speedometers">
      <Speedometer
        isLoading={!speedometerData}
        description="Cost Efficiency"
        startValue={startValue}
        value={speedometerData?.costEfficiency}
        segments={getDefaultColor4Segment(0.75, 0.85, 0.95, 1)}
      />
      <Speedometer
        isLoading={!speedometerData}
        description="Audit Quality"
        startValue={startValue}
        value={handleEmptyValue(speedometerData?.auditPercentage30)}
        segments={getDefaultColor4Segment(0.7, 0.8, 0.9, 1)}
      />
      <Speedometer
        isLoading={!speedometerData}
        description="Rejection Quality"
        startValue={startValue}
        value={handleEmptyValue(speedometerData?.rejectionAuditPercentage30, 1)}
        segments={getDefaultColor4Segment(0.7, 0.8, 0.9, 1)}
      />
    </MCard>
  );
};

export default QAPerformanceSpeedometers;
